import { useEffect, useState } from 'preact/hooks';
import waitForTimers from 'wait-for-timers';
import { classNames } from '../../utils/helpers';
import style from './style.module.scss';

export function LoadingBar({
  isLoading,
  className,
}: {
  isLoading: boolean;
  className?: string;
}) {
  const [loadingBarState, setLoadingBarState] = useState(
    isLoading ? 'visible' : 'hidden'
  );

  useEffect(() => {
    if (!isLoading) {
      setLoadingBarState('hidden');
      return waitForTimers([1000], () => setLoadingBarState('omit'));
    }
  }, [isLoading]);

  if (loadingBarState === 'omit') return null;
  return (
    <div
      class={classNames(
        `h-1 w-full transition-opacity duration-300 ease-out`,
        style['skeleton-animation'],
        loadingBarState === 'hidden' ? 'opacity-0' : 'opacity-100',
        className
      )}
    ></div>
  );
}
